export enum AdServerTargetKey {
  hb_bidder = 'hb_bidder',
  hb_adid = 'hb_adid',
  hb_pb = 'hb_pb',
  hb_size = 'hb_size',
  hb_mediaType = 'hb_mediaType',
  hb_s2sBidder = 'hb_s2sBidder'
}
